import React, { useEffect, useState } from 'react'
import { Modal, Row, Col, Button, Input, Form, message } from 'antd'
import { useAccountProfile } from '~/views/redux/hooks/useAccountProfile'
export default function modalEmailVerify(props) {
  const { action, t, checkNumberVerify } = props
  const [formEmail] = Form.useForm()
  const [inputValue, setInputValue] = useState('')
  const [checkVerify, setCheckVerify] = useState(0)
  const [minutes, setMinutes] = useState(4)
  const [seconds, setSeconds] = useState(59)
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds
    .toString()
    .padStart(2, '0')}`
  useEffect(() => {
    checkNumberVerify(checkVerify)
  }, [checkVerify])
  useEffect(() => {}, [action?.isModalVerifyFailedOpen])
  const rules = {
    code: [
      {
        required: true,
        message: t('validate.required', {
          0: 'Code',
        }),
      },
    ],
  }
  const handleVerify = (values) => {
    actions?.verifyEmail(
      {
        email_verify_code: values?.code,
      },
      (res) => {
        if (res.success === true) {
          action?.handleCancel()
          action?.showModalVerifySuccess()
        } else {
          action?.showModalVerifyFailed()
          setCheckVerify((prevCheckVerify) => prevCheckVerify + 1)
        }
      },
    )
  }
  const { actions } = useAccountProfile()

  useEffect(() => {
    if (action?.isModalOpen?.isOpen && action?.isModalOpen?.email !== null) {
      const intervalId = setInterval(() => {
        if (minutes === 0 && seconds === 0) {
          clearInterval(intervalId)
        } else if (seconds === 0) {
          setMinutes((prevMinutes) => prevMinutes - 1)
          setSeconds(59)
        } else {
          setSeconds((prevSeconds) => prevSeconds - 1)
        }
      }, 1000)
      return () => {
        clearInterval(intervalId)
      }
    }
  }, [action?.isModalOpen, minutes, seconds])

  const handleResendCode = () => {
    actions?.sendVerifyEmail(null, (res) => {
      if (res?.success === false) {
        message.error('Send verify Failed')
        setMinutes(0)
        setSeconds(0)
      } else {
        setMinutes(4)
        setSeconds(59)
      }
    })
  }

  const handleInputChange = (event) => {
    setInputValue(event.target.value)
  }

  useEffect(() => {
    setMinutes(4)
    setSeconds(59)
  }, [action?.isModalOpen])

  const closeModalVerifyEmail = () => {
    formEmail.resetFields(['code'])
    action?.handleCancel()
    setCheckVerify(0)
  }
  useEffect(() => {
    if (!action?.isModalOpen?.isOpen) {
      formEmail.resetFields(['code'])
      setCheckVerify(0)
    }
  }, [action?.isModalOpen])
  return (
    <>
      <Modal
        width={572}
        centered
        title={
          <h3 className="flex justify-center text-[20px] font-normal">
            {t('profile.accountSetting.modal.emailVerify.title')}
          </h3>
        }
        open={action?.isModalOpen?.isOpen}
        onCancel={closeModalVerifyEmail}
        footer={[]}
      >
        <Form
          layout="vertical"
          onFinish={handleVerify}
          form={formEmail}
          translate="yes"
          autoComplete="off"
          size="middle"
          validateTrigger={['onBlur', 'onChange']}
        >
          <div className="flex justify-center gap-5 pt-10 flex flex-wrap gap-2 w-full mb-2 ">
            <div>
              <Row>
                <Col
                  span={20}
                  className="my-[-50px] mb-[30px] font__M__plus text-[16px] font-bold"
                >
                  {t('profile.accountSetting.modal.emailVerify.message', {
                    email: action?.isModalOpen?.email,
                  })}
                  {t('profile.accountSetting.modal.emailVerify.message1')}
                </Col>

                <Col span={24} className="font__M__plus text-[16px] font-bold">
                  <Form.Item
                    label={
                      <span className="font__M__plus font-bold text-[16px]">
                        {t('profile.accountSetting.modal.emailVerify.message2')}
                      </span>
                    }
                    name="code"
                    rules={rules.code}
                    labelAlign="left"
                  >
                    <Input
                      className="h-[44px] my-4 text-black bg-white font__M__plus"
                      value={inputValue}
                      onChange={handleInputChange}
                      placeholder={t(
                        'profile.accountSetting.modal.emailVerify.message2',
                      )}
                    />
                  </Form.Item>

                  {(minutes > 0 || seconds > 0) && (
                    <div className="flex items-center justify-center">
                      <span className="mr-4 text-gray-300">
                        {t(
                          'profile.accountSetting.modal.emailVerify.resendCode',
                        )}
                      </span>
                      <span>{formattedTime}</span>
                    </div>
                  )}

                  {minutes === 0 && seconds === 0 && (
                    <div className="flex items-center justify-center">
                      <Button
                        onClick={() => {
                          handleResendCode()
                        }}
                        className={`w-[200px] h-[44px] rounded-md shadow-md border-none text-[16px] bg-orange-400`}
                        style={{ color: '#fff' }}
                      >
                        {t(
                          'profile.accountSetting.modal.emailVerify.resendCode',
                        )}
                      </Button>
                    </div>
                  )}
                </Col>

                <Col className="flex items-center justify-center w-full my-8 mb-[-44px]  ">
                  <Button
                    style={{ color: '#FFFFFF' }}
                    className=" w-full h-[44px] border-none text-[16px]"
                    onClick={action?.handleCancel}
                  >
                    {t('profile.accountSetting.modal.emailVerify.cancel')}
                  </Button>
                  <Button
                    htmlType="submit"
                    className={` btnOTPPhone w-full h-[44px] mt-1 ml-4 rounded-md shadow-md border-none text-[16px] ${
                      inputValue.length > 0
                        ? 'bg-orange-400'
                        : 'bg-orange-400 bg-opacity-50'
                    }`}
                    style={{ color: '#fff' }}
                  >
                    {t('profile.accountSetting.modal.emailVerify.verify')}
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  )
}
